<template>
    <company-autocomplete
        ref="companyAutocomplete"
        v-model="selectedCompany"
        :types="['CORPORATOR']"
        :label="`${$t('choose.company_long')}*`"
        phone-search
        outlined
    />
</template>

<script lang="ts">
    import {Component, VModel, Vue} from 'vue-facing-decorator'
    import CompanyAutocomplete from '@/components/account/modals/newOrderRequest/CompanyAutocomplete.vue'

    @Component({
        components: {CompanyAutocomplete},
    })
    export class CorporateClient extends Vue {
        @VModel() selectedCompany
    }

    export default CorporateClient
</script>
